<template>
  <div class="home-box">
    <div class="content-home">
      <HomeSection1 />
      <HomeSection2 />
      <HomeSection3 />
      <HomeSection4 />
      <HomeSection5 />
      <HomeSection6 />
    </div>
  </div>
</template>
<script>
import HomeSection1 from './component/section1'
import HomeSection2 from './component/section2'
import HomeSection3 from './component/section3'
import HomeSection4 from './component/section4'
import HomeSection5 from './component/section5'
import HomeSection6 from './component/section6'

export default {
  name: 'Home',
  components: {
    HomeSection1,
    HomeSection2,
    HomeSection3,
    HomeSection4,
    HomeSection5,
    HomeSection6
  },
  computed: {
    bgY: function () {
      return (
        document.getElementsByClassName('public-header')[0]?.offsetHeight ?? 266
      )
    }
  }
}
</script>
<style lang="scss" scoped>
.home-box {
  background-image: url(../../assets/image/home-bg.png);
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: 0 -60px;
  padding-top: 29px;
  .content-home {
    width: 1200px;
    margin: 0 auto 0;
  }
}
</style>
